import { z } from "zod";
import { isValidUrl } from "@/lib/utils/url-utils";

// Common validation schemas
export const commonSchemas = {
  // Text field with optional validation
  text: (minLength = 1, maxLength = 255) =>
    z
      .string()
      .min(minLength, `Must be at least ${minLength} characters`)
      .max(maxLength, `Must be no more than ${maxLength} characters`),

  // Email validation
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address"),

  // Password validation
  password: z
    .string()
    .min(8, "Password must be at least 8 characters")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    ),

  // Optional text field
  optionalText: (maxLength = 255) =>
    z
      .string()
      .max(maxLength, `Must be no more than ${maxLength} characters`)
      .optional(),

  // Phone number validation
  phone: z
    .string()
    .min(1, "Phone number is required")
    .regex(/^[+]?[1-9][\d]{0,15}$/, "Please enter a valid phone number"),

  // URL validation with TLD checking
  url: z
    .string()
    .min(1, "URL is required")
    .refine((val) => isValidUrl(val), {
      message: "Please enter a valid URL (invalid domain)",
    }),

  // Number validation
  number: (min = 0, max = Number.MAX_SAFE_INTEGER) =>
    z
      .number()
      .min(min, `Must be at least ${min}`)
      .max(max, `Must be no more than ${max}`),

  // Number string validation
  numberString: (min = 0, max = Number.MAX_SAFE_INTEGER) =>
    z
      .string()
      .min(min, `Must be at least ${min}`)
      .max(max, `Must be no more than ${max}`),

  // Boolean validation
  boolean: z.boolean(),

  // Date validation
  date: z.date().min(1, "Date is required"),
  // Wallet address validation
  walletAddress: z
    .string()
    .min(1, "Wallet address is required")
    .regex(/^0x[a-fA-F0-9]{40}$/, "Please enter a valid wallet address")
    .transform((val) => val as `0x${string}`),
};
